"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompensationSubcategories = exports.CompensationSubcategory = exports.CompensationCategories = exports.AvailableCompensationCategories = exports.CompensationCategory = void 0;
var CompensationCategory;
(function (CompensationCategory) {
    CompensationCategory["CANCELLATION"] = "cancellation";
    CompensationCategory["LAST_MINUTE_CHANGES"] = "last_minute_changes";
    CompensationCategory["FINANCIAL_ADJUSTMENTS"] = "financial_adjustments";
    CompensationCategory["CUSTOMER_NO_SHOW"] = "customer_no_show";
    CompensationCategory["OTHER"] = "other";
})(CompensationCategory || (exports.CompensationCategory = CompensationCategory = {}));
// Last minute changes are no longer available, but kept on CompensationCategories for backward UI compatibility
exports.AvailableCompensationCategories = {
    [CompensationCategory.CANCELLATION]: "Cancellation",
    [CompensationCategory.FINANCIAL_ADJUSTMENTS]: "Financial Adjustments",
    [CompensationCategory.CUSTOMER_NO_SHOW]: "Customer No Show",
    [CompensationCategory.OTHER]: "Other",
};
exports.CompensationCategories = {
    ...exports.AvailableCompensationCategories,
    [CompensationCategory.LAST_MINUTE_CHANGES]: "Last Minute Changes",
};
var CompensationSubcategory;
(function (CompensationSubcategory) {
    CompensationSubcategory["LATE_CANCELLATION_HOMETOWN"] = "late_cancellation_hometown";
    CompensationSubcategory["LATE_CANCELLATION_DIFF_LOCATION"] = "late_cancellation_diff_location";
    CompensationSubcategory["WAITING_FEE"] = "waiting_fee";
    CompensationSubcategory["AGREED_LAST_MINUTE_CHANGE"] = "agreed_last_minute_change";
    CompensationSubcategory["CUSTOMER_TIP"] = "customer_tip";
    CompensationSubcategory["BALANCE_ADJUSTMENT"] = "balance_adjustment";
    CompensationSubcategory["SOLIDARITY_FUND"] = "solidarity_fund";
    CompensationSubcategory["OTHER"] = "other";
})(CompensationSubcategory || (exports.CompensationSubcategory = CompensationSubcategory = {}));
exports.CompensationSubcategories = {
    [CompensationCategory.CANCELLATION]: {
        [CompensationSubcategory.LATE_CANCELLATION_HOMETOWN]: "Late cancellation from hometown",
        [CompensationSubcategory.LATE_CANCELLATION_DIFF_LOCATION]: "Late cancellation from different location",
        [CompensationSubcategory.OTHER]: "Other",
    },
    [CompensationCategory.LAST_MINUTE_CHANGES]: {
        [CompensationSubcategory.WAITING_FEE]: "Waiting fee",
        [CompensationSubcategory.AGREED_LAST_MINUTE_CHANGE]: "Agreed to a last-minute change",
        [CompensationSubcategory.OTHER]: "Other",
    },
    [CompensationCategory.FINANCIAL_ADJUSTMENTS]: {
        [CompensationSubcategory.CUSTOMER_TIP]: "Customer tip",
        [CompensationSubcategory.BALANCE_ADJUSTMENT]: "Balance adjustment",
        [CompensationSubcategory.SOLIDARITY_FUND]: "Solidarity fund",
        [CompensationSubcategory.OTHER]: "Other",
    },
    [CompensationCategory.CUSTOMER_NO_SHOW]: {},
    [CompensationCategory.OTHER]: {},
};
//# sourceMappingURL=CompensationCategory.js.map